import { getChannelInfoByAlias } from '@r1-frontend/api-domru/api-epg/v1/channels/alias';
import { getChannelInfo } from '@r1-frontend/api-domru/api-epg/v1/channels/id';
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import Tab from '@r1-frontend/ui-react/components/tabs/tab';
import Tabs from '@r1-frontend/ui-react/components/tabs/tabs';
import Router from 'next/router';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import ErrorPage from '~/pages/_error';
import Layout from '~/src/features/_layout';
import { getSchedule } from '~/src/features/domru-tv/api';
import ChannelDetail from '~/src/features/schedule/ChannelDetail';
import DescriptionDetail from '~/src/features/schedule/DescriptionDetail';
import { getPackagesWithChannel } from '~/src/features/schedule/getPackagesWithChannel';
import { addTimeToSchedule, broadcastsFilter, createDateList } from '~/src/features/schedule/helpers';
import ScheduleTooltip from '~/src/features/schedule/ScheduleTooltip';
import { initialProps } from '~/src/helpers/basePageFunc';
import getRequester from '~/src/helpers/getRequester';
import { permanentRedirect } from '~/src/helpers/url';
import { selectCompanyName } from '~/src/store/selectors/city';

const ScheduleContainer = styled.div`
    background-color: ${COLORS.white};
    display: block;
    flex-grow: 1;
    width: 100%;
`;

const ScheduleDetail = styled.section`
    margin-top: 7px;
    width: 100%;
`;

const ScheduleWrapper = styled.div`
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1440px;
    padding: 0 7%;
    width: 100%;

    @media screen and (max-width: 859px) {
        padding: 0 15px;
        width: 100%;
    }
`;

class ScheduleDetailPage extends React.Component {
    static async getInitialProps(options) {
        await initialProps(options);
        const { req, res, store, query: { alias } } = options;

        const doRequest = getRequester(req);

        const channelAlias = alias;

        const state = store.getState();
        const { provider: { providerId } } = state.city;
        const companyName = selectCompanyName(state);

        // Получаем информацию о канале
        const response = await doRequest.apiEPG(
            getChannelInfoByAlias(channelAlias, providerId),
        );
        if (!response.isSuccess) {
            res.status(404);
            return { channelInfo: null };
        }

        const channelInfo = {
            ...response.payload,
            button: response.payload.lcn,
            logo: response.payload?.channelInfo?.logo,
            chid: response.payload?.channelId,
            xvid: response.payload?.epgId,
        };

        // Информация о канале с ID
        const channelInfoId = channelInfo.chid;
        if (Number.isInteger(+alias)) {
            const channelInfoById = await doRequest.apiEPG(
                getChannelInfo(channelInfoId, providerId),
            );
            if (channelInfoById.isSuccess) {
                return permanentRedirect({
                    res,
                    location: `/domru-tv/channel/${channelInfoById.payload.alias}`,
                });
            }
        }

        // Редирект, если канал не должен показываться
        if ((Object.keys(channelInfo).length > 0) && ((!channelInfo.display) || (Number(channelInfo.display) & 1) !== 1)) {
            if (req) {
                res.writeHead(301, { Location: '/domru-tv/program' });
                res.end();
            } else {
                Router.push('/domru-tv/program');
            }
        }

        // Получаем пакет каналов
        const packageList = await getPackagesWithChannel(channelInfo.id, providerId);

        // xvid канала
        const xvidArray = [channelInfo.xvid];

        // Получаем расписание канала
        const dateList = createDateList();
        const schedules = await getSchedule({
            xvidArray,
            startDate: dateList[2].start,
            time: {
                start: {
                    hour: '0',
                    minute: '00',
                },
            },
        });


        let pastBroadcasts = null;
        let futureBroadcasts = null;

        const scheduleList = { ...addTimeToSchedule(schedules.isSuccess ? schedules.payload : []) };

        // Фильтруем программу и записываем

        if (scheduleList[xvidArray] !== undefined) {
            const filteredBroadcasts = broadcastsFilter(scheduleList[xvidArray]);
            pastBroadcasts = filteredBroadcasts.pastBroadcasts;
            futureBroadcasts = filteredBroadcasts.futureBroadcasts;
        }

        if (!channelInfo && res) {
            res.statusCode = 404;
        }

        return {
            channelInfo,
            packageList,
            xvid: xvidArray,
            dateList,
            scheduleList,
            pastBroadcasts,
            futureBroadcasts,
            companyName,
        };
    }

    constructor(props) {
        super(props);

        this.broadcastTimer = null;
        this.tooltipContainer = React.createRef();

        this.state = {
            currentDate: props.dateList?.length && props.dateList[2].start,
            dateList: props.dateList,
            scheduleList: props.scheduleList,
            futureBroadcasts: props.futureBroadcasts,
            pastBroadcasts: props.pastBroadcasts,
            tooltipData: {},
        };
    }

    async componentDidMount() {
        this.updateSchedule();
    }

    componentDidUpdate({ city }) {
        if (JSON.stringify(this.props.city) !== JSON.stringify(city)) {
            this.setState(() => ({
                scheduleList: {},
            }), this.updateSchedule);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.broadcastTimer);
    }

    updateProgress = () => {
        if (Array.isArray(this.state.scheduleList[this.props.xvid]) === false) {
            this.setState({
                pastBroadcasts: [],
                futureBroadcasts: [],
            });

            clearTimeout(this.broadcastTimer);
            return false;
        }

        const filteredBroadcasts = broadcastsFilter(this.state.scheduleList[this.props.xvid] || []);
        this.setState({
            pastBroadcasts: filteredBroadcasts.pastBroadcasts,
            futureBroadcasts: filteredBroadcasts.futureBroadcasts,
        });

        if (filteredBroadcasts.futureBroadcasts.length === 0) {
            clearTimeout(this.broadcastTimer);
            return false;
        }

        return true;
    }

    async updateSchedule() {
        if (!this.props.xvid) {
            return;
        }

        clearTimeout(this.broadcastTimer);
        const scheduleList = await  getSchedule({
            xvidArray: this.props.xvid,
            startDate: this.state.currentDate,
            time: {
                start: { hour: '0', minute: '00' },
                finish: { hour: '23', minute: '59' },
            },
        });
        this.setState({
            scheduleList: addTimeToSchedule(scheduleList.isSuccess ? scheduleList.payload : undefined),
        }, () => {
            const channelIsActive = this.updateProgress();

            if (channelIsActive) {
                this.broadcastTimer = setTimeout(this.updateProgress, 10000);
            }
        });
}

    onDateChange = async(tabName) => {
        const currentDate = this.state.dateList
            .filter(({ tabTitle }) => tabTitle === tabName)[0];

        this.setState(() => ({
            currentDate: currentDate.start,
            scheduleList: {},
        }), this.updateSchedule);
    }

    tooltipOpen = (content, coordinates) => {
        this.setState({
            tooltipData: {
                isShow: true,
                content,
                container: this.tooltipContainer.current,
                coordinates,
            },
        });
    }

    tooltipClose = () => {
        this.setState({
            tooltipData: {
                isShow: false,
                content: null,
            },
        });
    }

    render() {
        const { city, channelInfo, companyName, packageList = [] } = this.props;

        if (!channelInfo) {
            return <ErrorPage statusCode={404}/>;
        }

        const { dateList, futureBroadcasts, pastBroadcasts, tooltipData } = this.state;

        let tabsContainer = null;
        if (dateList.length > 0) {
            const tabs = dateList.map((date) => (
                <Tab
                    key={date.tabTitle}
                    label={date.tabTitle}
                >
                    {
                    futureBroadcasts
                    ? <ChannelDetail
                        futureBroadcasts={futureBroadcasts}
                        pastBroadcasts={pastBroadcasts}
                        tooltipOpen={this.tooltipOpen}
                    />
                    : ''
                    }
                </Tab>
            ));

            tabsContainer = (
                <Tabs activeTab={dateList[2].tabTitle} onSwitchTab={this.onDateChange}>
                    {tabs}
                </Tabs>
            );
        }

        let tooltip = null;

        if (tooltipData.isShow) {
            tooltip = (<ScheduleTooltip tooltipClose={this.tooltipClose} {...tooltipData} />);
        }

        return (
            <Layout
                withMenu={true}
                withChat={true}
                title={`Программа передач телеканала ${channelInfo.title} от ${companyName} в ${city.cityIn} | Телепрограмма канала на сегодня`}
                description={`Подключите канал ${channelInfo.title} от провайдера ${companyName}. Актуальная программа передач на сегодня, завтра и на неделю. Узнайте подробнее на нашем сайте!`}
            >
                <ScheduleContainer ref={this.tooltipContainer}>
                    <DescriptionDetail
                        channelInfo={channelInfo}
                        packageList={packageList}
                    />

                    <ScheduleDetail>
                        <ScheduleWrapper>
                            {tabsContainer}
                        </ScheduleWrapper>
                    </ScheduleDetail>
                    {tooltip}
                </ScheduleContainer>
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    city: state.city.currentCity,
});

export default connect(mapStateToProps)(ScheduleDetailPage);
